import { UploadMediaFilesDocument } from '@shared/api/graphql/generated';
import { removeUpload, uploadFile, UploadStatus } from '@shared/lib/uploads';
import type { AppThunk } from '@shared/store';
import { getVideoMediafileUploadTag } from './consts';

export const uploadVideoMediafile = (companyId: string, file: File, id: string = crypto.randomUUID()) =>
  uploadFile({
    id,
    tag: getVideoMediafileUploadTag(companyId),
    file,
    document: UploadMediaFilesDocument,
    variables: { input: { file, companyId } },
    filePath: 'input.file',
  });

export const retryVideoMediafileUpload =
  (companyId: string, id: string): AppThunk =>
  (dispatch, getState, { uploadFiles }) => {
    const item = getState().uploads.items[id];
    const file = uploadFiles.get(id);
    if (item?.tag !== getVideoMediafileUploadTag(companyId) || item.status !== UploadStatus.FAILED || !file) return;
    dispatch(uploadVideoMediafile(companyId, file, id));
  };

export const removeVideoMediafileUpload =
  (companyId: string, id: string): AppThunk =>
  (dispatch, getState) => {
    if (getState().uploads.items[id]?.tag === getVideoMediafileUploadTag(companyId)) dispatch(removeUpload(id));
  };

export const removeCompletedVideoMediafileUploads =
  (companyId: string, attempts: [string, string][]): AppThunk =>
  (dispatch, getState) => {
    attempts.forEach(([id, requestId]) => {
      const item = getState().uploads.items[id];
      if (
        item?.tag === getVideoMediafileUploadTag(companyId) &&
        item.requestId === requestId &&
        item.status === UploadStatus.SUCCEEDED
      ) {
        dispatch(removeUpload(id));
      }
    });
  };
